module.exports = __webpack_public_path__ + "static/media/soccer-ball.02a24a33.png";